<script>
import { mapGetters } from 'vuex';
import QuizOption from './QuizOption';

export default {
  name: 'QuizOptionList',
  components: {
    QuizOption
  },
  props: {
    options: Array,
    currentLevelIndex: Number,
  },
  data: () => {
    return {
      optionList: [],
    }
  },
  mounted() {
    this.options.forEach(item => {
      this.optionList.push(item);
    });
  },
  computed: {
    ...mapGetters({
      isLevelEnd: 'getIsLevelEnd',
      levelStats: 'getCurrentLevelStats',
    }),
  },
  watch: {
    isLevelEnd(newValue, oldValue) {
      if (newValue !== oldValue && newValue) {
        let $list = document.getElementsByClassName('quiz-option-list')[0];
        $list.style.height = $list.clientHeight + 'px';
        setTimeout(() => {
          this.optionList = [];
          $list.style.height = 0;
        }, 500);
      }
    },
  },
};
</script>

<template>
  <div class="quiz-option-list">
    <p class="quiz-option-list__overview" v-bind:class="{'quiz-option-list__overview--hidden': isLevelEnd}">
      {{$t('quiz.optionOverview', { a: levelStats.correctAnswered, b: levelStats.totalCorrectAnswers })}}
    </p>
    <transition-group name="fade" tag="div">
      <quiz-option 
        class="quiz-option-list__option"
        v-for="option in optionList" 
        v-bind:key="currentLevelIndex + option.title" 
        v-bind:option="option" />
    </transition-group>
  </div>
</template>

<style scoped lang="scss">
.quiz-option-list {
  max-width: 55rem;
  margin: -1rem auto;
  text-align: center;
  transition: height 500ms cubic-bezier(0.215, 0.61, 0.355, 1) 1000ms;
}

.quiz-option-list__option {
  display: inline-block;
  margin: .25rem .5rem;
  &:nth-child(4n+0) { transition-delay: 0; }
  &:nth-child(4n+1) { transition-delay: 100ms; }
  &:nth-child(4n+2) { transition-delay: 200ms; }
  &:nth-child(4n+4) { transition-delay: 300ms; }
}

.quiz-option-list__overview {
  margin: 2.6rem 0;
  font-family: var(--font-family-primary);
  font-size: 1.6rem;
  transition: opacity 200ms linear 500ms;
}

.quiz-option-list__overview--hidden {
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 400ms linear, transform 200ms cubic-bezier(0.175, 0.885, 0.32, 1.275);
}
.fade-enter {
  opacity: 0;
  transform: translateY(4rem);
}
.fade-leave-to {
  opacity: 0;
}

</style>
